import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["selectable"];

  select(event) {
    console.log("single selected?");
    this.selectableTargets.forEach((target, index) => {
      if (event.target !== target) {
        target.setAttribute("disabled", true);
      }
    });
  }

  selectableTargetConnected() {
    this.selectableTargets.forEach((target, index) => {
      target.removeAttribute("disabled");
    });
  }
}
